import React from 'react';
import { Helmet } from 'react-helmet';
import Layout from 'gatsby-theme-pdv/src/gatsby-theme-core/layout/layout';
import CookieBar from 'gatsby-theme-cookie-consent/src/cookie-bar';

const PdVNLLayout = (props) => (
  <>
    <Helmet>
      <script
        key="calldrip"
        type="text/javascript"
        src="https://app.calldrip.eu/js/widget.js#$2y$10$SOtp6cOSnpPdSDy1GEY7uOc.FEBUy5tgIeRwFxJ9tf4AvFECp6bUe"
        data-account-key="$2y$10$5EWpwxdQNA9QsB1bBkruruS94toL9U/sFOuPmsTUisch3EPqOK322"
      />
    </Helmet>
    <Layout {...props} preheader={<CookieBar />} />
  </>
);

export default PdVNLLayout;
